// This JavaScript file is created by Cision for our newsfeed.
// This is the first version of this file so far.
// This should be combined with relese.html

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.newsfeed = !cision.websolution.settings.newsfeed ? {} : function ($) {

    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = cision.websolution.settings.newsfeed.accessKey,
        texts = cision.websolution.texts[settings.uiLanguage];

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }

    var renderListing = function (options) {

        if (options) {
            $.extend(settings, options);
        }

        if (options.accessKey) {
            accessKey = options.accessKey;
        }

        if (!accessKey) {
            console.log("You must provide your newsfeed access key.");
            return;
        }
        var url = generateUrl('NewsFeed/' + accessKey + '/Releases');

        var d = $.Deferred();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                startDate: settings.startDate,
                endDate: settings.endDate,
                pageIndex: settings.pageIndex,
                pageSize: settings.pageSize,
                searchTerm: settings.searchTerm,
                separateFirstRelease: settings.separateFirstRelease,
                tags: settings.tags,
                regulatory: settings.regulatory
            }
        })
            .done(function (objResponse) {
                var objFirstRelease = null,
                    releaseList = [];

                $.each(objResponse.Releases, function (idx, objRelease) {
                    objRelease.PublishDateFormatted = moment(objRelease.PublishDate).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objRelease.DetailUrl = settings.serviceEndpoint + 'Release/' + objRelease.EncryptedId;
                    objRelease.years = objRelease.PublishDateFormatted.slice(0, 4);

                    objRelease.HasImage = objRelease.Images && objRelease.Images.length > 0;
                    if (settings.useMediabankViaHttps) {
                        if (objRelease.HasImage) {
                            $.each(objRelease.Images, function (index, objImage) {
                                objImage.DownloadUrl = objImage.DownloadUrl.replace('http:', 'https:');
                                objImage.UrlTo100x100ArResized = objImage.UrlTo100x100ArResized.replace('http:', 'https:');
                                objImage.UrlTo200x200ArResized = objImage.UrlTo200x200ArResized.replace('http:', 'https:');
                                objImage.UrlTo400x400ArResized = objImage.UrlTo400x400ArResized.replace('http:', 'https:');
                                objImage.UrlTo800x800ArResized = objImage.UrlTo800x800ArResized.replace('http:', 'https:');
                                objImage.UrlTo100x100Thumbnail = objImage.UrlTo100x100Thumbnail.replace('http:', 'https:');
                                objImage.UrlTo200x200Thumbnail = objImage.UrlTo200x200Thumbnail.replace('http:', 'https:');
                            });
                        }
                    }

                    var encodedTitle = objRelease.EncodedUrl || objRelease.Title.toLowerCase().replace(/[öø]/g, "o").replace(/[åä]/g, "a").replace(/[éèëê]/g, "e").replace(/[ûü]/g, "u").replace(/[^a-z0-9]+/gi, '-').replace(/\-+/g, "-");
                    objRelease.TitleForUrl = encodeURI(encodedTitle);

                    objRelease.ThumbnailUrl = '';
                    try {
                        objRelease.ThumbnailUrl = objRelease.Images[0].UrlTo400x400ArResized;
                    } catch (e) {

                    }

                    // Shorten text
                    if (settings.introMaxLength && settings.introMaxLength > 0) {

                        if (objRelease.Intro.length > settings.introMaxLength) {
                            objRelease.Intro = $.trim(objRelease.Intro).substring(0, settings.introMaxLength) + "...";
                        }
                    }

                    if (settings.titleMaxLength && settings.titleMaxLength > 0) {

                        if (objRelease.Title.length > settings.titleMaxLength) {
                            objRelease.Title = $.trim(objRelease.Title).substring(0, settings.titleMaxLength) + "...";
                        }
                    }

                    if (settings.separateFirstRelease === true && objFirstRelease === null) {
                        objFirstRelease = objRelease;
                        if (objFirstRelease.HasImage) {
                            objFirstRelease.ImageUrl = objRelease.Images[0].DownloadUrl;
                        }
                    } else {
                        releaseList.push(objRelease);
                    }
                });

                objResponse.Releases = releaseList;
                objResponse.PreviousPageExists = objResponse.PageIndex > 0;
                objResponse.PreviousPageIndex = Math.max(1, objResponse.PageIndex - 1);
                objResponse.NextPageIndex = objResponse.PageIndex + 1;
                objResponse.NextPageExists = (objResponse.PageIndex * objResponse.PageSize) < objResponse.TotalFoundReleases;
                objResponse.PageCount = Math.ceil(objResponse.TotalFoundReleases / objResponse.PageSize);

                var compositeModel = $.extend({}, objResponse, texts),
                    images = ['Images/Bildbank/background-image1.jpg', 'Images/Bildbank/background-image2.jpg', 'Images/Bildbank/background-image3.jpg', 'Images/Bildbank/background-image4.jpg', 'Images/Bildbank/background-image5.jpg', 'Images/Bildbank/background-image6.jpg', 'Images/Bildbank/background-image7.jpg', 'Images/Bildbank/background-image8.jpg', 'Images/Bildbank/background-image9.jpg'],
                    currentImageFallbackIx = 0,
                    helpers = $.extend(cision.websolution.formatHelpers,
                        {
                            getFallbackImage: function () {
                                var imgSrc = images[currentImageFallbackIx++];
                                if (currentImageFallbackIx >= images.length)
                                    currentImageFallbackIx = 0;
                                return imgSrc;
                            }

                        });

                var compositeModelFirst = $.extend({}, objFirstRelease, texts);
                if (settings.separateFirstRelease === true) {
                    var renderedHtmlFirst = $("#tplTopRelease").render(compositeModelFirst, helpers, settings);
                    $("#target-release-top").html(renderedHtmlFirst);
                }

                var renderedHtml = $("#tplReleaseList").render(compositeModel, helpers, settings);
                $("#target-release-list").html(renderedHtml);

                if (releaseList.length < 1 && objFirstRelease === null) {
                    var toRender = $.extend(texts, cision.websolution.settings.general),
                        renderTpl = $("#tplnosearchResult").render(toRender);
                    $('#noSearchresult-container').html(renderTpl);
                    $('#noSearchresult-container').show();
                } else {
                    $('#noSearchresult-container').hide();
                }

                d.resolve();
            })
            .fail(function () {
                console.log('Could not retrieve data');
                d.reject();
            });
        return d.promise();
    }

    var renderYears = function (options) {

        if (options) {
            $.extend(settings, options);
        }

        if (options.accessKey) {
            accessKey = options.accessKey;
        }

        if (!accessKey) {
            console.log("You must provide your newsfeed access key.");
            return;
        }
        var url = generateUrl('NewsFeed/' + accessKey + '/Years?startYear=1980');

        var d = $.Deferred();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json'
        })
            .done(function (objResponse) {
                var yearList = [];

                $.each(objResponse.Years, function (idx, objRelease) {
                    yearList.push(objRelease);
                });

                yearList.reverse();
                objResponse.Years = yearList;

                var compositeModel = $.extend({}, objResponse, texts, settings);
                var renderedHtml = $("#tplArchive").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-archive").html(renderedHtml);
                d.resolve();

            })
            .fail(function () {
                console.log('Could not retrieve years');
                d.reject();
            });

        return d.promise();
    };

    var renderHighlights = function (options) {

        if (options) {
            $.extend(settings, options);
        }

        if (options.accessKey) {
            accessKey = options.accessKey;
        }

        if (!accessKey) {
            console.log("You must provide your highlights access key.");
            return;
        }
        var url = generateUrl('NewsFeed/' + accessKey + '/Releases');

        var d = $.Deferred();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                startDate: settings.startDate,
                endDate: settings.endDate,
                pageIndex: settings.pageIndex,
                pageSize: settings.pageSize
            }
        })
            .done(function (objResponse) {
                var releaseList = [];

                $.each(objResponse.Releases, function (idx, objRelease) {
                    objRelease.PublishDateFormatted = moment(objRelease.PublishDate).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objRelease.DetailUrl = settings.serviceEndpoint + 'Release/' + objRelease.EncryptedId;

                    var encodedTitle = objRelease.EncodedUrl || objRelease.Title.toLowerCase().replace(/[öø]/g, "o").replace(/[åä]/g, "a").replace(/[éèëê]/g, "e").replace(/[ûü]/g, "u").replace(/[^a-z0-9]+/gi, '-').replace(/\-+/g, "-");
                    objRelease.TitleForUrl = encodeURI(encodedTitle);

                    objRelease.ThumbnailUrl = '';
                    try {
                        objRelease.ThumbnailUrl = objRelease.Images[0].UrlTo400x400ArResized;
                    } catch (e) {

                    }

                    releaseList.push(objRelease);
                });

                objResponse.Releases = releaseList;

                var compositeModel = $.extend({}, objResponse, texts, settings);

                var renderedHtml = $("#tplHighlighted").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-highlights").html(renderedHtml);

                d.resolve();
            })
            .fail(function () {
                console.log('Could not retrieve data');
                d.reject();
            });

        return d.promise();
    }

    var renderDetail = function (options) {

        if (options) {
            $.extend(settings, options);
        }

        if (!settings.releaseIdentifier) {
            console.log("You must provide a release Encrypted ID.");
            return;
        }
        var url = generateUrl('Release/' + settings.releaseIdentifier + '/Detail');
        var d = $.Deferred();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json'
        })
            .done(function (objResponse) {

                var objRelease = objResponse.Release;
                objRelease.PublishDateFormatted = moment(objRelease.PublishDate).locale(settings.uiLanguage).format(settings.dateFormatNews);
                objRelease.DetailUrl = settings.serviceEndpoint + 'Release/' + objRelease.EncryptedId;

                objRelease.HasImage = objRelease.Images && objRelease.Images.length > 0;
                if (settings.useMediabankViaHttps) {
                    if (objRelease.HasImage) {
                        $.each(objRelease.Images, function (index, objImage) {
                            objImage.DownloadUrl = objImage.DownloadUrl.replace('http:', 'https:');
                            objImage.UrlTo100x100ArResized = objImage.UrlTo100x100ArResized.replace('http:', 'https:');
                            objImage.UrlTo200x200ArResized = objImage.UrlTo200x200ArResized.replace('http:', 'https:');
                            objImage.UrlTo400x400ArResized = objImage.UrlTo400x400ArResized.replace('http:', 'https:');
                            objImage.UrlTo800x800ArResized = objImage.UrlTo800x800ArResized.replace('http:', 'https:');
                            objImage.UrlTo100x100Thumbnail = objImage.UrlTo100x100Thumbnail.replace('http:', 'https:');
                            objImage.UrlTo200x200Thumbnail = objImage.UrlTo200x200Thumbnail.replace('http:', 'https:');
                        });
                        objRelease.HtmlBody = objRelease.HtmlBody.replace('http:', 'https:');
                    }
                    $.each(objRelease.Files, function (index, objFile) {
                        objFile.Url = objFile.Url.replace('http:', 'https:');
                    });

                }


                if (objRelease.Files) {
                    $.each(objRelease.Files, function (idx, objFile) {
                        var ext = objFile.FileName.split('.').pop();
                        objFile.FileType = ext || 'unknown-file-extension';
                    });
                }

                var compositeModel = $.extend({}, objRelease, texts, settings),
                    renderedHtml = $("#tplReleaseDetail").render(compositeModel, cision.websolution.formatHelpers);

                $("#target-release-detail").html(renderedHtml);

                d.resolve();

            })
            .fail(function () {
                console.log('Could not retrieve release Detailed data');
                d.reject();
            });

        return d.promise();
    };


    var renderContactsAndAbout = function (options) {

        if (options) {
            $.extend(settings, options);
        }

        if (options.accessKey) {
            accessKey = options.accessKey;
        }

        if (!accessKey) {
            console.log("You must provide your newsroom access key.");
            return;
        }
        var url = generateUrl('NewsRoom/' + accessKey);

        $.ajax({
            url: url,
            data: {
                siteKey: settings.siteKey
            },
            type: 'GET',
            dataType: 'json'
        })
            .done(function (objResponse) {
                var compositeModel = $.extend({}, objResponse, texts, settings);

                var $tplNewsroomAbout = $("#tplNewsroomAbout");
                var $targetNewsroomAbout = $("#target-newsroom-about");

                if ($tplNewsroomAbout.length && $targetNewsroomAbout.length) {
                    var renderedHtmlAbout = $tplNewsroomAbout.render(compositeModel);
                    $targetNewsroomAbout.html(renderedHtmlAbout);
                }

                var $tplLogoUrl = $("#tplNewsroomLogoUrl");
                var $targetLogoUrl = $("#target-newsroom-logo");

                if ($tplLogoUrl.length && $targetLogoUrl.length) {
                    var renderedHtmlLogoUrl = $tplLogoUrl.render(compositeModel);
                    $targetLogoUrl.html(renderedHtmlLogoUrl);
                }

                var $tplNewsroomContactListDetail = $("#tplNewsroomContactListDetail");
                var $targetNewsroomContactListDetail = $("#target-newsroom-contact-list-detail");

                if ($tplNewsroomContactListDetail.length && $targetNewsroomContactListDetail.length) {
                    var renderedHtmlContactsDetail = $tplNewsroomContactListDetail.render(compositeModel);
                    $targetNewsroomContactListDetail.html(renderedHtmlContactsDetail);
                }

                var $tplNewsroomContactListSidebar = $("#tplNewsroomContactListSidebar");
                var $targetNewsroomContactListSidebar = $("#target-newsroom-contact-list-sidebar");

                if ($tplNewsroomContactListSidebar.length && $targetNewsroomContactListSidebar.length) {
                    var renderedHtmlContactsSidebar = $tplNewsroomContactListSidebar.render(compositeModel);
                    $targetNewsroomContactListSidebar.html(renderedHtmlContactsSidebar);
                }
            })
            .fail(function () {
                console.log('Could not retrieve newsroom contacts');
            });
    };

    var renderTags = function (options) {
        if (options) {
            settings.showNumberOfTags = options.showNumberOfTags;
            $.extend(settings, options);

            if (options.accessKey) {
                accessKey = options.accessKey;
            }
        }
        if (!accessKey) {
            console.log("You must provide your newsfeed access key.");
            return;
        }
        var url = generateUrl('Newsroom/' + accessKey + '/Tags');

        var d = $.Deferred();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                languageCodes: settings.uiLanguage,
                pageSize: 100
            }
        })
            .done(function (objResponse) {
                var tagList = [];

                $.each(objResponse.Tags, function (idx, objRelease) {
                    tagList.push(objRelease);
                });

                objResponse.Tags = tagList;
                objResponse.numberOfTags = tagList.length;

                var compositeModel = $.extend({}, objResponse, texts, settings);
                var renderedHtml = $("#tplTags").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-tags").html(renderedHtml);
                d.resolve();

            })
            .fail(function () {
                console.log('Could not retrieve tags');
                d.reject();
            });

        return d.promise();
    };

    return {
        render: renderListing,
        renderListing: renderListing,
        renderDetail: renderDetail,
        renderYears: renderYears,
        renderContactsAndAbout: renderContactsAndAbout,
        renderHighlights: renderHighlights,
        renderTags: renderTags
    };
}(jQuery);